/* Legacy redirect for old SEO URLs:
     /jobs/in-riviere-du-rempart  →  /jobs/location/riviere-du-rempart
     /jobs/in/riviere-du-rempart  →  /jobs/location/riviere-du-rempart

   Handles the splat (*) route by parsing window.location.pathname.
*/
import React, { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { CITIES } from "../lib/seoTaxonomy";

const normalise = (s) => (s || "")
  .toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "") // strip accents
  .replace(/\s+/g, "-")
  .replace(/[^a-z0-9-]/g, "");

export default function LegacyCityRedirect() {
  const params = useParams();
  const location = useLocation();

  // Compute the candidate slug from either:
  //  - useParams().slug (matches /jobs/in/:slug)
  //  - the splat after /jobs/in-  (matches /jobs/in-*)
  let candidate = params.slug || "";
  if (!candidate) {
    // pathname like '/jobs/in-riviere-du-rempart' (splat) → strip prefix
    const m = /\/jobs\/in-(.+)/i.exec(location.pathname || "");
    if (m) candidate = m[1];
  }
  candidate = normalise(decodeURIComponent(candidate));

  // Try to resolve to a known city slug (slug match OR alias contains the candidate)
  const known = CITIES.find((c) => c.slug === candidate)
    || CITIES.find((c) => (c.aliases || []).some((a) => normalise(a) === candidate))
    || CITIES.find((c) => (c.aliases || []).some((a) => normalise(a).includes(candidate) || candidate.includes(normalise(a))));

  useEffect(() => {
    // Set a soft 301-equivalent hint for crawlers via meta refresh fallback (browsers will follow Navigate immediately).
    const el = document.createElement("meta");
    el.setAttribute("http-equiv", "refresh");
    el.setAttribute("content", "0; url=" + (known ? `/jobs/location/${known.slug}` : "/jobs/locations"));
    document.head.appendChild(el);
    return () => { try { document.head.removeChild(el); } catch (_) {} };
  }, [known]);

  if (known) return <Navigate to={`/jobs/location/${known.slug}`} replace />;
  // Unknown slug → send the visitor to the cities index (still indexable, still useful)
  return <Navigate to="/jobs/locations" replace />;
}
